// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreateStreamPopup__form-popup-a24a2f {
  flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/CreateStreamPopup/CreateStreamPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF","sourcesContent":[".form-popup {\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form-popup": `CreateStreamPopup__form-popup-a24a2f`,
	"formPopup": `CreateStreamPopup__form-popup-a24a2f`
};
module.exports = ___CSS_LOADER_EXPORT___;
